import { GTM_EVENT_ACTIONS } from '../../constants';

export const GTM_EVENTS = {
  MATCH_CLICK: {
    event: 'match_click',
    action: GTM_EVENT_ACTIONS.CLICK,
  },
};
